// Check if the uesr is minor
export const isMinor = (day: string, month: string, year: string): boolean => {
  const currentDate = new Date();
  const newDay = day?.trim();
  const newMonth = month?.trim();
  const newYear = year?.trim();

  const birthDate = new Date(+newYear, +newMonth - 1, +newDay);

  let age = currentDate.getFullYear() - birthDate.getFullYear();

  if (
    currentDate.getMonth() < birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() &&
      currentDate.getDate() < birthDate.getDate())
  ) {
    age -= 1;
  }

  return age < 18;
};
